import { lazy } from 'react';
import serviceAreasPendingRoutes from './ServiceAreasPendingRoute';

const ServiceAreasCurrentPage = lazy(() => import('./ServiceAreasCurrentPage'));
const NotFound = lazy(() => import('../../app/views/NotFound'));

const serviceAreasRoutes = [
  {
    path: 'service-areas',
    children: [
      { index: true, element: <ServiceAreasCurrentPage /> },
      { path: 'theatre-list', element: <ServiceAreasCurrentPage /> },
      ...serviceAreasPendingRoutes,
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default serviceAreasRoutes;
